import React from "react";
import AudienceIcon from "../../images/Svg/Audience.svg";
import ContentIcon from "../../images/Svg/Content.svg";
import MobilePostIcon from "../../images/Svg/MobilePost.svg";
import slider1 from "../../images/Svg/slider1.svg";
import slider2 from "../../images/Svg/slider2.svg";

import { Swiper, SwiperSlide } from "swiper/react";

// Import Swiper styles
import "swiper/css";
import "swiper/css/pagination";

// import required modules
import { Pagination, Autoplay } from "swiper";

const Slider = () => {
  return (
    <section className="bg-[#0b135a] text-white my-[50px] md:my-32 px-6 sm:px-6 md:px-16 items-center">
      <div className="lg:hidden container mx-auto py-10 sm:p-10 small_slider">
        <Swiper
          direction="horizontal"
          pagination={{
            clickable: true,
          }}
          loop={true}
          autoplay={{
            delay: 4000,
            disableOnInteraction: true,
          }}
          modules={[Pagination, Autoplay]}
          className="mySwiper"
          mousewheel={true}
        >
          <SwiperSlide>
            <h1 className="font-bold mb-4 Secondheading">
              Perks of being a <span className="text-blue"> DeSo </span>
              Creator
            </h1>
            <div className="flex justify-center flex-wrap mb-8">
              <div>
                <div>
                  <p className="text-base text-blue mb-[8px]">Creator Coins</p>
                  <p className="text-[14px] mb-[16px]">
                    Creator coins are social tokens that convert brand value
                    into a tradable asset. This is a new monetisation stream for
                    creators
                  </p>
                </div>
                <img className="mx-auto" src={slider1} alt="" />
              </div>
              <div className="mt-8 mb-8">
                <p className="text-base text-blue mb-[8px]">Social Tipping</p>
                <p className=" mt-[8px] mb-[16px] text-[14px]">
                  Creators receive meaningful engagement. It is far more
                  profitable to go viral on decentralised social media rather
                  than on private platforms
                </p>
                <img className="mx-auto" src={slider2} alt="" />
                <div></div>
              </div>
            </div>
          </SwiperSlide>

          <SwiperSlide>
            <div className="flex items-center h-[760px]">
              <div className="grid sm:grid-cols-1 md:grid-cols-1 lg:grid-cols-2 gap-6 items-center md:mt-10 w-[90%] mx-auto">
                <div>
                  <h1 className="text-3xl sm:text-3xl md:text-5xl title font-bold mx-auto">
                    Getting into Web 3.0 as soon as possible will help you{" "}
                    <span className="text-blue">create</span> and{" "}
                    <span className="text-blue"> grow </span> your brand value.
                  </h1>
                  <p className="text-[20px] mt-8">
                    So what are you waiting for?
                  </p>
                </div>

                <div className="pt-[48px]">
                  <div className="rounded-[8px] bg-gray-200 shadow-lg total-earning p-20 mx-auto">
                    <p className="text-base">Total No. of Creators</p>
                    <h1 className="text-blue text-[48px] mt-4 font-bold">
                      650K
                    </h1>
                  </div>
                  <div className="rounded-[8px] bg-gray-200 shadow-lg total-earning p-20 mx-auto mt-[24px]">
                    <p className="text-base">No. of Engagements</p>
                    <h1 className="text-blue text-[48px] mt-4 font-bold">
                      73.7M
                    </h1>
                  </div>
                </div>
              </div>
            </div>
          </SwiperSlide>

          <SwiperSlide>
            <div className="grid sm:grid-cols-1 md:grid-cols-1 lg:grid-cols-2 gap-6 items-center w-[90%] mx-auto">
              <div>
                <h1 className="text-3xl sm:text-4xl title font-bold text-[#FFFFFF]">
                  We understand the problem that you are facing right now
                </h1>
                <div>
                  <div className="flex items-ceter mt-12">
                    <img
                      width={"84px"}
                      height={"84px"}
                      src={AudienceIcon}
                      alt=""
                    />
                    <img
                      width={"84px"}
                      height={"84px"}
                      className="ml-12"
                      src={ContentIcon}
                      alt=""
                    />
                  </div>
                  <p className="text-[20px] mt-8">
                    Your <span className="text-blue">content</span> and{" "}
                    <span className="text-blue">audience </span>
                    are on web 2.0 platforms
                  </p>
                </div>
              </div>
              <div className="pt-[24px]">
                <h1 className="text-3xl sm:text-4xl title font-bold ">
                  Making it difficult to
                  <span className="text-blue"> manually </span> shift your
                  <span className="text-blue"> content </span> and
                  <span className="text-blue"> audience </span> to a newer and
                  better platform
                </h1>
                <p className="mt-10 text-[20px]">
                  But don't worry <br />
                  We’ve made it simple for you to do so!
                </p>
              </div>
            </div>
          </SwiperSlide>

          <SwiperSlide>
            <div className="grid sm:grid-cols-1 md:grid-cols-1 lg:grid-cols-2 gap-6 items-center mx-auto">
              <div>
                <h1 className="title font-bold text-3xl sm:text-4xl">
                  With Setu
                </h1>
                <h1 className="title font-bold text-3xl sm:text-4xl">
                  Expanding your Brand
                </h1>
                <p className="text-[20px] mt-4">
                  is as easy as tweeting about your newest content!
                </p>
              </div>
              <div className="mt-12">
                <img className="mx-auto" src={MobilePostIcon} alt="" />
              </div>
            </div>
          </SwiperSlide>
        </Swiper>
      </div>

      <div className="hidden sm:hidden lg:inline container mx-auto p-16 slider">
        <Swiper
          direction={"vertical"}
          pagination={{
            clickable: true,
          }}
          loop={true}
          autoplay={{
            delay: 4000,
            disableOnInteraction: true,
          }}
          modules={[Pagination, Autoplay]}
          className="mySwiper swiper1"
          mousewheel={true}
        >
          <SwiperSlide>
            <div className="container mx-auto px-6 sm:px-6 md:px-16">
              <div>
                <h1 className="mb-4 mx-auto mt-12 Secondheading font-bold">
                  Perks of being a <span className="text-blue"> DeSo </span>
                  Creator
                </h1>
                <div className="grid sm:grid-cols-1 md:grid-cols-1 lg:grid-cols-2 gap-6 mt-[40px]">
                  <div className="max-w-[500px] w-[100%]">
                    <div className="mb-[16px]">
                      <p className="text-base font-bold text-blue">
                        Creator Coins
                      </p>
                      <p>
                        Creator coins are social tokens that convert brand value
                        into a tradable asset. This is a new monetisation stream
                        for creators
                      </p>
                    </div>
                  </div>
                  <div className="max-w-[500px] w-[90%]">
                    <div className="mb-[16px]">
                      <p className="text-base text-blue font-bold">
                        Social Tipping
                      </p>
                      <p>
                        Creators receive meaningful engagement. It is far more
                        profitable to go viral on decentralised social media
                        rather than on private platforms
                      </p>
                    </div>
                  </div>
                  <div>
                    <img src={slider1} alt="" />
                  </div>
                  <div>
                    <img src={slider2} alt="" />
                  </div>
                </div>
              </div>
            </div>
          </SwiperSlide>

          <SwiperSlide>
            <div className="flex items-center h-[760px] ">
              <div className="container mx-auto grid sm:grid-cols-1 md:grid-cols-1 lg:grid-cols-2 gap-6 items-center px-6 sm:px-6 md:px-16">
                <div>
                  <h1 className="heading title font-bold ">
                    Getting into Web 3.0 as soon as possible will help you{" "}
                    <span className="text-blue">create</span> and{" "}
                    <span className="text-blue"> grow </span> your brand value.
                  </h1>
                  <p className="text-base mt-8">So what are you waiting for?</p>
                </div>
                <div className="mr-10 mx-auto max-w-[600px] w-[90%]">
                  <div>
                    <div className="rounded-[8px] bg-gray-200 shadow-lg total-earning p-20 mx-auto">
                      <p className="text-[14px]">Total No. of Creators</p>
                      <h1 className="text-blue text-[48px] mt-4 font-bold">
                        650K
                      </h1>
                    </div>
                    <div className="rounded-[8px] bg-gray-200 shadow-lg total-earning p-20 mx-auto mt-[24px]">
                      <p className="text-[14px]">No. of Engagements</p>
                      <h1 className="text-blue text-[48px] font-bold mt-4">
                        73.7M
                      </h1>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </SwiperSlide>

          <SwiperSlide>
            <div className="flex items-center h-[760px] ">
              <div className="container mx-auto grid sm:grid-cols-1 md:grid-cols-1 lg:grid-cols-2 gap-6 items-center px-6 sm:px-6 md:px-16">
                <div className="md_padding">
                  <h1 className="heading title font-bold text-[#FFFFFF] pr-[20px]">
                    We understand the problem that you are facing right now
                  </h1>
                  <div>
                    <div className="flex items-ceter pt-[100px]">
                      <img
                        width={"84px"}
                        height={"84px"}
                        src={ContentIcon}
                        alt=""
                      />
                      <img
                        width={"84px"}
                        height={"84px"}
                        className="ml-12"
                        src={AudienceIcon}
                        alt=""
                      />
                    </div>
                    <p className="text-base mt-8">
                      Your <span className="text-blue">content </span> and{" "}
                      <span className="text-blue">audience </span>
                      are on web 2.0 platforms
                    </p>
                  </div>
                </div>
                <div>
                  <h1 className="heading title font-bold">
                    Making it difficult to{" "}
                    <span className="text-blue">manually</span> shift your
                    <span className="text-blue"> content </span> and
                    <span className="text-blue"> audience </span> to a newer and
                    better platform
                  </h1>
                  <p className="mt-16 text-base">
                    But don't worry <br />
                    We’ve made it simple for you to do so!
                  </p>
                </div>
              </div>
            </div>
          </SwiperSlide>

          <SwiperSlide>
            <div className="flex items-center h-[760px]">
              <div className="container mx-auto grid sm:grid-cols-1 md:grid-cols-1 lg:grid-cols-2 gap-6 items-center px-6 sm:px-6 md:px-16">
                <div>
                  <p>With Setu</p>
                  <h1 className="heading title font-bold ">
                    Expanding your Brand
                  </h1>
                  <p className="mt-4">
                    is as easy as tweeting about your newest content!
                  </p>
                </div>
                <div>
                  <img src={MobilePostIcon} alt="" />
                </div>
              </div>
            </div>
          </SwiperSlide>
        </Swiper>
      </div>
    </section>
  );
};

export default Slider;
